const env = (!process.env.BUILD_ENV || process.env.BUILD_ENV === 'mock' ? 'mock' : 'requests');
// eslint-disable-next-line import/no-dynamic-require
const API = require(`./${env}`);

export default API.default;
